import React, { useState } from 'react';
import { Mail, CheckCircle, Bell } from 'lucide-react';
import './Subscribe.css';

const Subscribe = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interests: {
      allEvents: true,
      seasonal: false,
      cultural: false,
      themed: false
    },
    agreedToRules: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name.startsWith('interests.')) {
        const interestKey = name.split('.')[1];
        setFormData(prev => ({
          ...prev,
          interests: {
            ...prev.interests,
            [interestKey]: checked
          }
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [name]: checked
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would normally send to your backend/email service
    console.log('Subscription data:', formData);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="subscribe-page">
        <section className="subscribe-success section">
          <div className="container">
            <div className="subscribe-success-content">
              <CheckCircle size={80} className="subscribe-success-icon" />
              <h1>Welcome to the B2P Family!</h1>
              <p>
                Thank you for subscribing, {formData.name}! You'll receive party invitations 
                and updates at <strong>{formData.email}</strong>
              </p>
              <p className="subscribe-reminder">
                Remember: We only invite people who respect the earth, each other, and our 
                gathering spaces. Let's party every night - responsibly.
              </p>
              <a href="/" className="btn btn-orange">
                Back to Home
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="subscribe-page">
      {/* Header */}
      <section className="subscribe-header">
        <div className="container">
          <div className="subscribe-header-content">
            <Bell size={48} className="subscribe-header-icon" />
            <h1>Subscribe to B2P</h1>
            <p>
              Join our community and receive invitations to conscious celebrations, parties, 
              and events where connection and respect come first.
            </p>
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="subscribe-form-section section">
        <div className="container">
          <form onSubmit={handleSubmit} className="subscribe-form">
            <div className="subscribe-form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </div>

            <div className="subscribe-form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
              />
            </div>

            <div className="subscribe-form-group">
              <label>Event Interests</label>
              <div className="subscribe-checkboxes">
                <label className="subscribe-checkbox">
                  <input
                    type="checkbox"
                    name="interests.allEvents"
                    checked={formData.interests.allEvents}
                    onChange={handleChange}
                  />
                  <span>All Events</span>
                </label>
                <label className="subscribe-checkbox">
                  <input
                    type="checkbox"
                    name="interests.seasonal"
                    checked={formData.interests.seasonal}
                    onChange={handleChange}
                  />
                  <span>Seasonal Celebrations (Solstice, Equinox)</span>
                </label>
                <label className="subscribe-checkbox">
                  <input
                    type="checkbox"
                    name="interests.cultural"
                    checked={formData.interests.cultural}
                    onChange={handleChange}
                  />
                  <span>Cultural Events (Halloween, Day of the Dead)</span>
                </label>
                <label className="subscribe-checkbox">
                  <input
                    type="checkbox"
                    name="interests.themed"
                    checked={formData.interests.themed}
                    onChange={handleChange}
                  />
                  <span>Themed Gatherings</span>
                </label>
              </div>
            </div>

            <div className="subscribe-rules">
              <h3>Community Rules</h3>
              <ul>
                <li><strong>Leave No Trace</strong> - Take your rubbish with you</li>
                <li><strong>Respect the Earth</strong> - Pack in, pack out</li>
                <li><strong>Respect Each Other</strong> - Mutual respect creates connection</li>
                <li><strong>Be Authentic</strong> - Just be cool and come party</li>
                <li><strong>Keep the Secret</strong> - Don't share locations publicly</li>
              </ul>
              <label className="subscribe-checkbox subscribe-agree">
                <input
                  type="checkbox"
                  name="agreedToRules"
                  checked={formData.agreedToRules}
                  onChange={handleChange}
                  required
                />
                <span>I agree to follow the B2P community rules and values *</span>
              </label>
            </div>

            <button type="submit" className="btn btn-orange" disabled={!formData.agreedToRules}>
              <Mail size={20} />
              Subscribe Now
            </button>
          </form>
        </div>
      </section>

      {/* Info Section */}
      <section className="subscribe-info section bg-gray">
        <div className="container">
          <div className="subscribe-info-content">
            <h2>What You'll Receive</h2>
            <div className="subscribe-benefits">
              <div className="subscribe-benefit">
                <CheckCircle className="subscribe-benefit-icon" />
                <h3>Event Invitations</h3>
                <p>Be the first to know about upcoming parties and celebrations</p>
              </div>
              <div className="subscribe-benefit">
                <CheckCircle className="subscribe-benefit-icon" />
                <h3>Location Details</h3>
                <p>Receive exact meeting points after RSVP confirmation</p>
              </div>
              <div className="subscribe-benefit">
                <CheckCircle className="subscribe-benefit-icon" />
                <h3>Community Updates</h3>
                <p>Stay connected with the B2P family and upcoming artists</p>
              </div>
              <div className="subscribe-benefit">
                <CheckCircle className="subscribe-benefit-icon" />
                <h3>After Party Access</h3>
                <p>Invitation opportunities for respectful community members</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Subscribe;

